import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, IonInput } from '@ionic/angular/lazy';
import { CashTrackingService } from 'src/app/services/cash-tracking.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import { Decimal } from 'decimal.js';

@Component({
    selector: 'app-cash-tracking-start-tracking',
    templateUrl: './cash-tracking-start-tracking.page.html',
    styleUrls: ['./cash-tracking-start-tracking.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CashTrackingStartTrackingPage implements OnInit {

    supported_currencies = null;
    cash_tracking_session_floats = [];

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cashTrackingService: CashTrackingService,
        private supportedCurrencyService: SupportedCurrencyService
    ) { }

    ngOnInit() {

        this.supportedCurrencyService.getSupportedCurrencies().then(async (supported_currencies) => {

            if(supported_currencies) {

                this.supported_currencies = supported_currencies;

                for(let i = 0; i < this.supported_currencies.length; i++) {
                    if (this.supported_currencies[i].base === true) {
                        let base_currency = this.supported_currencies.splice(i, 1)[0];
                        this.supported_currencies.unshift(base_currency);
                        break;
                    }
                }

                for(let i = 0; i < this.supported_currencies.length; i++) {
                    let float = {};
                    float['title'] = this.supported_currencies[i].title + ' (' + this.supported_currencies[i].code + ')';
                    float['currency_id'] = this.supported_currencies[i].id;
                    float['price'] = null;
                    float['note'] = null;
                    this.cash_tracking_session_floats.push(float);
                }

            }
        })
        .catch(() => {});

    }

    close() {
        this.modalController.dismiss();
    }

    start() {

        let validated = true;
        let float_has_price = false;
        let price_regex = /^\d+(\.\d+)?$/;

        for(let i = 0; i < this.cash_tracking_session_floats.length; i++) {

            let float = this.cash_tracking_session_floats[i];

            if(float.price != null && float.price != "") {

                float_has_price = true;

                if(!price_regex.test(String(float.price).toLowerCase())) {

                    if(this.supported_currencies.length > 1) {
                        this.presentAlert("Invalid float", "The float for " + float.title + " is invalid.");
                    }
                    else {
                        this.presentAlert("Invalid float", "The float is invalid.");
                    }

                    validated = false;
                    break;

                }
            }
        }

        // catch empty floats
        if(!float_has_price) {

            if(this.supported_currencies.length > 1) {
                this.presentAlert("Missing float", "You need to set a float in at least one currency.");
            }
            else {
                this.presentAlert("Missing float", "You need to set a float.");
            }
            
            validated = false;

        }

        if(validated) {

            let cash_tracking_session_floats = [];

            for(let i = 0; i < this.cash_tracking_session_floats.length; i++) {

                if(this.cash_tracking_session_floats[i].price != null && this.cash_tracking_session_floats[i].price != "") {

                    // ensure 2dp
                    this.cash_tracking_session_floats[i].price = Number(new Decimal(this.cash_tracking_session_floats[i].price).toDecimalPlaces(2));

                    // prevent empty note
                    if(this.cash_tracking_session_floats[i].note == null || this.cash_tracking_session_floats[i].note.trim() === "") {
                        this.cash_tracking_session_floats[i].note = null;
                    }

                    // push to array
                    cash_tracking_session_floats.push({
                        currency_id: this.cash_tracking_session_floats[i].currency_id,
                        price: this.cash_tracking_session_floats[i].price,
                        note: this.cash_tracking_session_floats[i].note,
                    });

                }
            }

            this.cashTrackingService.addCashTracking(cash_tracking_session_floats).then(() => {
                this.modalController.dismiss();
            })
            .catch(() => {});

        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
